// TODO: replace with real data once the X-Ray chat feature has a backend.
// Shape mirrors what `getSurveyMembers` already returns per respondent, plus
// new fields (`chatMessageCount`, `lastActiveLabel`, `hasUnreadChat`, `isActive`)
// that a future API response would add.
//
// 4 real scenarios per respondent, only 3 of which ever show up in the UI:
//   1. Active   + chatted     -> normal row
//   2. Active   + not chatted -> "no conversation yet" row
//   3. Deactivated + chatted  -> normal row + "Deactivated" tag, chat still viewable
//   4. Deactivated + not chatted -> excluded entirely, nothing to show or view
export const DUMMY_RESPONDENTS = [
  { userId: "1", firstName: "Rasesh", lastName: "Bhavsar", chatMessageCount: 14, lastActiveLabel: "4 Aug", hasUnreadChat: true, isActive: true },
  { userId: "2", firstName: "Parth", lastName: "Thakkar", chatMessageCount: 6, lastActiveLabel: "2 Aug", hasUnreadChat: false, isActive: true },
  { userId: "3", firstName: "Michael", lastName: "Scott", chatMessageCount: 9, lastActiveLabel: "1 Aug", hasUnreadChat: false, isActive: false },
  { userId: "4", firstName: "Priya", lastName: "Nair", chatMessageCount: 3, lastActiveLabel: "30 Jul", hasUnreadChat: false, isActive: true },
  { userId: "5", firstName: "Alex", lastName: "Chen", chatMessageCount: 1, lastActiveLabel: "28 Jul", hasUnreadChat: false, isActive: true },
  { userId: "6", firstName: "Jordan", lastName: "Davis", chatMessageCount: 0, lastActiveLabel: null, hasUnreadChat: false, isActive: true },
  { userId: "7", firstName: "Sara", lastName: "Iyer", chatMessageCount: 0, lastActiveLabel: null, hasUnreadChat: false, isActive: true },
  { userId: "8", firstName: "Tom", lastName: "Reed", chatMessageCount: 0, lastActiveLabel: null, hasUnreadChat: false, isActive: true },
  { userId: "9", firstName: "Nina", lastName: "Patel", chatMessageCount: 0, lastActiveLabel: null, hasUnreadChat: false, isActive: true },
  // scenario 4 (deactivated, never chatted) — deliberately included to prove
  // it gets filtered out and never reaches the list or a viewable chat.
  { userId: "10", firstName: "Dev", lastName: "Kapoor", chatMessageCount: 0, lastActiveLabel: null, hasUnreadChat: false, isActive: false },
];

// TODO: replace with a real fetch of this respondent's X-Ray chat history
// once the backend endpoint exists. Message shape matches what ProjectChat
// already expects: { sender: "user" | "assistant", message, files }.
export const getDummyMessages = () => [
  {
    sender: "assistant",
    message: `Welcome — here's where your business stands.\n\nThe X-Ray assessed your business across the 8 core disciplines of scaling. Right now strategy is the clearest gap holding growth back — your business model and market positioning aren't strong enough yet to support sustainable growth.`,
    files: [],
  },
  {
    sender: "user",
    message:
      "Do you know what products we serve because I think then only you can guide us better",
    files: [],
  },
  {
    sender: "assistant",
    message:
      "Based on your X-Ray responses, here's what stands out about your current offering, and where the gaps are versus what the market actually needs from you right now.",
    files: [],
  },
];
